export default __webpack_public_path__ + "static/media/wheel-2.b3a2be94.png";